import React, { useState, useContext, useEffect } from "react";
import MyStoreHome from "./MyStoreHome";
import MyStoreProducts from "./MyStoreProducts";
import MyStoreOverview from "./MyStoreOverview";
import AboutMyStore from "./AboutMyStore";
import MyStoreContact from "./MyStoreContact";
import { useNavigate } from "react-router-dom";
import { addAboutUsSectionApi, addCompanyOverviewApi, toggleProductApi } from "../../../Apis/WebStoreApi";
import { UserAuthContext } from "../../../App";

const storeTabsHeader = [
  "Home",
  "Products",
  "Overview",
  "About us",
  "Contact us",
];

const MyStore = () => {
  const [storeTabs, setStoreTabs] = useState(0);
  const [companyOverview, setCompanyOverview] = useState("");
  const [selectedFeatures, setSelectedFeatures] = useState([]);
  const [addedTop, setAddedTop] = useState([]);
  const [isVisible, setIsVisible] = useState([]);

  const [aboutUs, setAboutUs] = useState("");

  const { userUid } = useContext(UserAuthContext);

  const navigate = useNavigate();

  const handleSaveChanges = async () => {
    if(storeTabs === 1) {
      try{
        await toggleProductApi(addedTop, isVisible);
      }catch(error){
        console.log("Failed to save added to top and is visible", error)
      }
    }else if (storeTabs === 2) {
      try {
        await addCompanyOverviewApi(companyOverview, selectedFeatures);
      } catch (error) {
        console.log("Failed to save company overview:", error);
      }
    } else if (storeTabs === 3) {
      try {
        await addAboutUsSectionApi(aboutUs);
      } catch (error) {
        console.log("Failed to save about us section:", error);
      }
    } else {
      console.log("Save changes for other tabs");
    }
  };
  


  useEffect(() => {
    if (userUid?.currentUser?.uid) {
      handleSaveChanges();
    }
  }, [userUid?.currentUser?.uid]);

  return (
    <div className="w-[1014px] h-[935px] bg-[#FFF9F2] rounded-r-[10px] flex flex-col py-[31px] px-[36px] justify-between text-center">
      <div className="flex flex-row items-center justify-between">
        <div className="flex flex-col">
          <h3 className="w-[107px] h-[24px] text-black text-start font-semibold text-[16px]">
            My Webstore
          </h3>
          <hr className="w-[152px] h-[3px] bg-[#FF6300] rounded-full mt-[9px]" />
        </div>
        <div className="flex flex-row w-[305px] items-center justify-between">
          <button
            className="w-[133px] h-[38px] bg-[#FF6300] rounded-[5px] font-semibold text-[14px] text-white flex items-center justify-center"
            onClick={handleSaveChanges}
          >
            Save Changes
          </button>
          <button
            className="w-[160px] h-[38px] bg-white rounded-[5px] text-black flex items-center justify-center border font-semibold text-[14px]"
            onClick={() => navigate("/WebFrontPage")}
          >
            Preview Webstore
          </button>
        </div>
      </div>

      <p className="w-[941px] h-[84px] font-medium text-[14px] text-start text-black leading-[28px]">
        Welcome to My Webstore, where you can transform your online storefront.
        Easily customize your website settings to showcase your products and
        promotional banners. Empower your online presence and captivate your
        audience with effortless website management.
      </p>

      <div className="w-[941px] h-[703px] bg-white rounded-[5px] pt-[29px] pb-[26px] px-[22px] flex flex-col drop-shadow-[0_0px_3px_rgba(0,0,0,0.10)]">
        <div className="flex w-[891px] pb-[3px] justify-around">
          {storeTabsHeader.map((tab, index) => (
            <button
              key={index}
              className={`-mb-px border-b-2 transition-all duration-300 w-[111px] h-[32px] ${
                storeTabs === index
                  ? "border-[#FF6300] text-black font-semibold text-[16px]"
                  : "border-transparent text-black font-semibold text-[16px]"
              }`}
              onClick={() => setStoreTabs(index)}
            >
              {tab}
            </button>
          ))}
        </div>
        <div className="w-[891px] h-[640px] relative">
          {storeTabs === 0 && <MyStoreHome />}
          {storeTabs === 1 && <MyStoreProducts addedTop={addedTop} setAddedTop={setAddedTop} isVisible={isVisible} setIsVisible={setIsVisible}  />}
          {storeTabs === 2 && (
            <MyStoreOverview
              companyOverview={companyOverview}
              setCompanyOverview={setCompanyOverview}
              selectedFeatures={selectedFeatures}
              setSelectedFeatures={setSelectedFeatures}
            />
          )}
          {storeTabs === 3 && <AboutMyStore aboutUs={aboutUs} setAboutUs={setAboutUs} />}
          {storeTabs === 4 && <MyStoreContact />}
        </div>
      </div>
    </div>
  );
};

export default MyStore;
